export default "__VITE_ASSET__903ccc18__"